import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { purchases } from '../data/purchases';
const INTERVAL_MS = 15000;
const VISIBLE_MS = 5000;
const FIRST_DELAY_MS = 6000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: ReturnType<typeof setTimeout>;
    let count = 0;
    const show = () => {
      setIndex(count % purchases.length);
      count += 1;
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), VISIBLE_MS);
    };
    const firstTimer = setTimeout(show, FIRST_DELAY_MS);
    const interval = setInterval(show, INTERVAL_MS);
    return () => {
      clearTimeout(firstTimer);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, [dismissed]);
  const purchase = purchases[index];
  return <div className="pointer-events-none fixed bottom-3 left-3 right-3 z-50 sm:bottom-5 sm:left-5 sm:right-auto" aria-live="polite" data-id="element-171" data-mp="117o1lpknur0f">
      <AnimatePresence data-id="element-172" data-mp="1fv0s7spbrmxo">
        {visible && !dismissed && <motion.div key={index} initial={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full max-w-[320px] items-center gap-3 rounded-2xl border border-line bg-white p-3 pr-8 shadow-[0_16px_40px_-16px_rgba(43,33,24,0.4)] sm:w-auto" role="status" data-id="element-173" data-mp="1awfsdudzj59r">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gold-light" data-id="element-174" data-mp="23lmzvivf3575">
              <ShoppingBagIcon className="h-5 w-5 text-gold-dark" aria-hidden="true" data-id="element-175" data-mp="2ap3037xgwma4" />
            </span>
            <div className="min-w-0 text-left" data-id="element-176" data-mp="2fmv3ay3kbutm">
              <p className="truncate text-[13px] font-bold text-ink" data-id="element-177" data-mp="2fpr1mnjbolil">
                {purchase.name} · {purchase.city}, {purchase.country}
              </p>
              <p className="text-xs text-muted" data-id="element-178" data-mp="2pksp7exy9fj2">
                Compró el pack completo · hace {purchase.minutesAgo} min
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 ease-out hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" aria-label="Cerrar notificaciones de compra" data-id="element-179" data-mp="1rw8wtb97iilq">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-180" data-mp="1972hzzbjab57" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}